/* ============================================
   TUFF TIPS — THEME JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── PRODUCT GRID FILTER ──────────────────────
  var filterBtns = document.querySelectorAll('.filter-btn');
  var productCards = document.querySelectorAll('.product-card[data-cat]');

  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filterBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var filter = btn.dataset.filter;
      productCards.forEach(function (card) {
        var cats = card.dataset.cat || '';
        card.style.display = (filter === 'all' || cats.indexOf(filter) !== -1) ? '' : 'none';
      });
    });
  });

  // ── ADD TO CART (AJAX) ────────────────────────
  document.querySelectorAll('.product-add[data-product-id]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = btn.dataset.productId;
      if (!variantId) return;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added!';
        updateCartCount();
        setTimeout(function () {
          btn.textContent = 'Add';
          btn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        btn.textContent = 'Error';
        btn.disabled = false;
      });
    });
  });

  // ── ADD TO CART FORM (PRODUCT PAGE) ──────────
  var addToCartForm = document.getElementById('add-to-cart-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = addToCartForm.querySelector('[type="submit"]');
      var variantId = document.getElementById('variant-id').value;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added to Cart!';
        updateCartCount();
        setTimeout(function () {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        btn.textContent = 'Error — Try Again';
        btn.disabled = false;
      });
    });
  }

  // ── VARIANT SELECTOR (PRODUCT PAGE) ──────────
  var optionBtns = document.querySelectorAll('.option-btn');
  if (optionBtns.length && typeof productVariants !== 'undefined') {
    var selectedOptions = {};

    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var position = btn.dataset.option;
        var value = btn.dataset.value;
        selectedOptions[position] = value;

        // Update active state within same option group
        document.querySelectorAll('.option-btn[data-option="' + position + '"]').forEach(function (b) {
          b.classList.remove('active');
        });
        btn.classList.add('active');

        // Find matching variant
        var match = productVariants.find(function (v) {
          return v.options.every(function (opt, i) {
            var pos = String(i + 1);
            return !selectedOptions[pos] || selectedOptions[pos] === opt;
          });
        });

        if (match) {
          var variantInput = document.getElementById('variant-id');
          if (variantInput) variantInput.value = match.id;
          var priceEl = document.getElementById('product-price');
          if (priceEl) priceEl.textContent = formatMoney(match.price);
          var addBtn = addToCartForm ? addToCartForm.querySelector('[type="submit"]') : null;
          if (addBtn) {
            addBtn.disabled = !match.available;
            addBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
          }
        }
      });
    });
  }

  // ── PRODUCT IMAGE THUMBNAILS ──────────────────
  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('main-product-image');
      if (mainImg && thumb.dataset.full) {
        mainImg.src = thumb.dataset.full;
      }
      document.querySelectorAll('.product-thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  // ── CART COUNT UPDATE ─────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.querySelector('.nav-cart');
        if (el) {
          el.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> &nbsp;Cart (' + cart.item_count + ')';
        }
      });
  }

  // ── MONEY FORMATTER (ZAR) ─────────────────────
  function formatMoney(cents) {
    return 'R ' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

});
